/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */
import CardsMatrix from './CardsMatrix';

/**
 * CardsMatrix module exports
 */
export { CardsMatrix as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CardsMatrix/index.js